import type { IUserRepository } from '../repositories/IUserRepository.js';
import type { UserEntity } from '../entities/UserEntity.js';

interface Dependencies {
  userRepository: IUserRepository;
}

export function createGetUsersByIdsUseCase({ userRepository }: Dependencies) {
  return async function getUsersByIds(ids: string[]): Promise<UserEntity[]> {
    return userRepository.getByIds(ids);
  };
}
